// Persist dismissed site toast in sessionStorage until the tab is closed.
(function () {
	function initSiteToastSession() {
		var root = document.querySelector('.js-site-toast[data-toast-session-key]');
		if (!root) {
			return;
		}
		var key = root.getAttribute('data-toast-session-key');
		if (!key) {
			return;
		}
		try {
			if (window.sessionStorage.getItem(key) === '1') {
				root.classList.remove('modal--is-visible');
			}
		} catch (e) {
			// Private mode or storage disabled
		}
		root.addEventListener('modalIsClose', function () {
			try {
				window.sessionStorage.setItem(key, '1');
			} catch (e) {
				// Private mode or storage disabled
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSiteToastSession);
	} else {
		initSiteToastSession();
	}
})();
